
export const supplierHubEmailLimits ={
    subject: 200,
    body: 2000,
};